import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import BlogCardComponent from "./components/BlogCard";

// Fonction pour récupérer les articles publics du blog
const getPublicBloggerPosts = async (blogId) => {
  try {
    const response = await fetch(
      `https://www.googleapis.com/blogger/v3/blogs/${blogId}/posts?key=${process.env.REACT_APP_API_KEY}`
    );
    const data = await response.json();
    return data.items || [];
  } catch (error) {
    console.error("Erreur lors de la récupération des articles publics :", error);
    return [];
  }
};

const Blog = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      const blogId = "156638923842745856"; // Remplacez par l'ID de votre blog
      const fetchedPosts = await getPublicBloggerPosts(blogId);
      setPosts(fetchedPosts);
    };
    fetchPosts();
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Blog | Les Z'ineuvitables - Théâtre Solidaire à Neuville-en-Ferrain</title>
        <meta
          name="description"
          content="Découvrez les derniers articles du blog de la troupe théâtrale 'Les Z'Ineuvitables' à Neuville-en-Ferrain, suivez le flux de la troupe."
        />
        <meta
          name="keywords"
          content="théâtre, création, solidarité, troupe amateur, articles, Les Z'ineuvitables, Neuville-en-Ferrain, spectacles, salle Malraux, événements culturels, billetterie"
        />
        <meta property="og:title" content="Blog | Les Z'ineuvitables - Théâtre Solidaire à Neuville-en-Ferrain" />
        <meta
          property="og:description"
          content="Découvrez les derniers articles du blog de la troupe théâtrale 'Les Z'ineuvitables' à Neuville-en-Ferrain."
        />
        <meta property="og:url" content="https://www.zineuvitables.org/blog" />
        <meta property="og:image" content="https://www.zineuvitables.org/logo-zineuvitables.png" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="fr_FR" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Blog | Les Z'ineuvitables - Théâtre Solidaire à Neuville-en-Ferrain" />
        <meta
          name="twitter:description"
          content="Découvrez les derniers articles du blog de la troupe théâtrale 'Les Z'ineuvitables' à Neuville-en-Ferrain."
        />
        <meta name="twitter:image" content="https://www.zineuvitables.org/logo-zineuvitables.png" />
      </Helmet>

      <Layout>
        <Cover>
          <CoverContent>
            <CoverTitle>🚀Les Derniers Articles</CoverTitle>
            <ShortDescription>
              Découvrez les actualités de la troupe de théâtre "les Z'Ineuvitables" et leurs partenaires, ne manquez aucun évenement ou spectacle, suivez notre flux ou alors nos réseaux !
            </ShortDescription>
            {posts.length > 0 ? (
              <ArticlesGrid>
                {posts.slice(0, 4).map((post) => (
                  <a key={post.id} href={post.url} target="_blank" rel="noopener noreferrer" className="card-link">
                    <BlogCardComponent article={post} />
                  </a>
                ))}
              </ArticlesGrid>
            ) : (
              <p>Aucun article à afficher pour le moment.</p>
            )}
          </CoverContent>
        </Cover>
      </Layout>
    </>
  );
};

export default Blog;

// Styled Components
const Layout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: 0;
  padding: 0;
`;

const Cover = styled.section`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: white;
  text-align: center;
  margin-bottom: 0;
  overflow: hidden;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: -1;
  }

  @media (max-width: 768px) {
    height: auto;
    padding: 20px;
  }
`;

const CoverContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 100%;
  padding: 30px;
  border-radius: 10px;
  backdrop-filter: blur(5px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
   color: #007bff
`;

const CoverTitle = styled.h2`
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(100, 10, 10, 0.5);
  @media (max-width: 480px) {
    font-size: 2rem;
 

  }
`;

const ShortDescription = styled.p`
  font-size: 1.2rem;
  color: #f0f0f0;
  margin-bottom: 30px;
  line-height: 1.6;
  max-width: 80%;
  margin: 0 auto;
  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const ArticlesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 20px;
  padding: 0 20px;
`;
